import axios from "axios";

const ARK_API_URL = process.env.ARK_API_URL;

export const sendContactByEmail = async (formData) => {
  try {
    await axios.post(`${ARK_API_URL}/mailer`, formData);
    return true;
  } catch (error) {
    console.error("Error fetching posts:", error);
  }
};